var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"formRules"},[_c('b-form',{ref:"editForm"},[_c('form-fields',{attrs:{"module":_vm.module,"loading":_vm.loading,"submit-button":true},on:{"onSubmitButtonClick":_vm.submitForm}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }